export enum RoleType {
    SuperAdmin = 1,
    OperationHead = 2,
    Manager = 3,
    Lead = 4,
    Specialist = 5,
    External = 6,
    QA = 7
}